<template>
  <div>
    <!-- echarts -->
    <div ref="main" class="main_container"></div>
  </div>
</template>
<script>
import * as echarts from "echarts";
export default {
  data() {
    return {};
  },
  props: {
    // id: Number,
    // chartData: {},
    options: {},
  },
  watch: {
    options: {
      deep: true,
      handler() {
        this.initCharts();
        console.log('update option');
      },
    },
  },
  mounted() {
    this.initCharts();
  },
  methods: {
    initCharts() {
      // 初始化echarts实例
      var myChart = echarts.init(this.$refs.main);
      // 绘制图表
      myChart.setOption(this.options);
    },
  },
};
</script>
<style lang="scss" scoped>
.main_container {
  width: 100%;
  height: 300px;
  overflow: hidden;
}
</style>